import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-collection',
  templateUrl: './collection.component.html',
  styleUrls: ['./collection.component.scss']
})
export class CollectionComponent implements OnInit {
  collectionLink = environment.link_collection;

  constructor() { }

  ngOnInit() {
    // Redirect to external link
    window.location.href = this.collectionLink;
  }
}
